<template>
  <div>
    <div v-show="sideSquare">
      <a
        v-for="ad in sideSquare"
        :key="ad.id"
        :href="resolveAdUrl(ad)"
        @click.prevent="handleAdClick(ad, routeName)"
        @mouseover="handleAdHoverStart()"
        @mouseout="handleAdHoverEnd(ad)"
      >
        <img
          :src="ad.photo"
          class="w-[300px] h-[250px] px-2 mx-auto md:px-0"
          alt=""
        />
      </a>
    </div>
    <SearchTypes />
    <div class="sticky top-32">
      <div class="mt-10" v-show="sideLong">
        <a
          v-for="ad in sideLong"
          :key="ad.id"
          :href="resolveAdUrl(ad)"
          @click.prevent="handleAdClick(ad, routeName)"
          @mouseover="handleAdHoverStart()"
          @mouseout="handleAdHoverEnd(ad)"
        >
          <img
            :src="ad.photo"
            class="w-[300px] h-[600px] px-2 mx-auto md:px-0"
            alt=""
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useAds } from "@/composables/useAds";
import SearchTypes from "@/features/properties/SearchTypes.vue";
import { useRouter } from "vue-router";
export default {
  components: {
    SearchTypes,
  },
  name: "AdBanner",
  setup() {
    const router = useRouter();
    const routeName = router.currentRoute.value.fullPath;
    const {
      sideSquare,
      sideLong,
      handleAdClick,
      handleAdHoverStart,
      handleAdHoverEnd,
      resolveAdUrl,
      loadAds,
    } = useAds();

    onMounted(() => {
      loadAds();
    });

    return {
      routeName,
      sideSquare,
      sideLong,
      handleAdClick,
      handleAdHoverStart,
      handleAdHoverEnd,
      resolveAdUrl,
    };
  },
};
</script>
